import React from 'react';
import formatCurrency from '../../func/currency_formatter';

const CardFullBundle = ({ handleCardClick, data, styles, labels, displayBadges, outOfStock }) => {
	let totalAmount = data.formatted_total_amount
		? data.formatted_total_amount
		: formatCurrency(data.amount * data.price);
	let oldPrice = data?.formatted_old_price ? data?.formatted_old_price : formatCurrency(Number(data?.old_price));

	if (outOfStock) {
		totalAmount = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, Number(1 * data?.amount).toFixed(2))
			: formatCurrency(Number(1.0 * data.amount));
		oldPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, '1.00')
			: formatCurrency(Number(1));
	}

	return (
		<div
			className="productsRows__item"
			onClick={() => {
				handleCardClick();
			}}
			style={styles?.card}
		>
			<div className="productsRows__itemHeading" style={styles?.heading}>
				{outOfStock ? 'Out Of Stock' : data.status}
			</div>
			<div className="productsRows__itemContentWrap">
				<div className="image__wrapper">
					<img
						className="productsRows__itemImage mon-img-176-h"
						src={data.image.url}
						alt="product x4"
						style={{ height: '100%', width: 'auto' }}
					/>
				</div>
				{displayBadges && !outOfStock && (
					<div className="productsRows__itemPerks productsRows__itemPerks--active productsRows__itemPerks--package">
						<div style={styles?.shippingBadge}>{labels?.shipping}</div>
						<div style={styles?.savingsBadge}>
							{labels?.saveLabel} -{data.you_save_percentage}%
						</div>
					</div>
				)}
				<div className="itemPackageContent">
					<div className="itemPackageContent__itemNumber" style={styles?.primaryColor}>
						{data.amount}x
					</div>
					<div className="itemPackageContent__itemName" style={styles?.primaryColor}>
						{data.display_name}
					</div>
					<div className="itemPackageContent__itemTotal" style={styles?.priceColor}>
						{totalAmount}
					</div>
					<div className="itemPackageContent__itemTotalDiscount" style={styles?.totalColor}>
						{!outOfStock && oldPrice}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CardFullBundle;
